import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var defaultProps = {
  disableGutters: true
};
var styleOverrides = {
  root: function root(_ref) {
    var theme = _ref.theme;
    return _defineProperty({
      backgroundColor: theme.palette.primary[25],
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      '& .MuiPaper-root': {
        maxHeight: 'fit-content',
        minWidth: theme.breakpoints.values.sm,
        maxWidth: theme.breakpoints.values.sm,
        padding: theme.spacing(5)
      }
    }, theme.breakpoints.down('md'), {
      padding: 0,
      '& .MuiPaper-root': {
        minWidth: '100%',
        minHeight: '100%'
      }
    });
  }
};
export default {
  defaultProps: defaultProps,
  styleOverrides: styleOverrides
};